import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { faPhone, faPhoneVolume, faShippingFast, faShoppingCart, faWallet, faBoxesStacked, faBullhorn } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Company } from 'service';
import { ACCOUNTS_PHONENUMBER, DISPATCH_PHONENUMBER, ENQUIRY1_PHONENUMBER, ENQUIRY2_PHONENUMBER, ORDERS_PHONENUMBER } from 'service/Utils';
import ArthaGateway from 'service/ArthaGateway';
import { Loader } from '../Widgets';
import { NavLink } from 'react-router-dom';

export const ContactDetails = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [company, setCompany] = useState<Company>();
    const [phoneNumbers, setPhoneNumbers] = useState<Array<{ icon: any, number: string, label: string }>>([]);

    const icons = {
        faPhoneVolume,
        faShoppingCart,
        faShippingFast,
        faBoxesStacked,
        faBullhorn,
        faWallet
    };

    useEffect(() => {
        fetch("./contacts.json")
        .then((res) => res.json())
        .then((data) => {
            setPhoneNumbers(data);
            console.log(data);
        });
    }, []);

    useEffect(() => {
        if (user.profile) {
            fetchCompanyDetails();
        }
    }, [user]);

    const fetchCompanyDetails = () => {
        const cachedCompany = sessionStorage.getItem("company");
        if (cachedCompany) {
            setCompany(JSON.parse(cachedCompany));
            setIsLoading(false);
        }
        else {
            ArthaGateway
                .getCompany(1)
                .then((data) => {
                    setCompany(data);
                    sessionStorage.setItem("company", JSON.stringify(data));
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    };

    return (
        <div className="page page-contact-details">
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    <div className="row">
                        <div className="col-md-6">
                            <div className='card mb-2'>
                                <div className="card-header bg-dark text-white">
                                    <h5 className="card-title">Contact Details</h5>
                                </div>
                                {company &&
                                    <>
                                        <div className="card-body">
                                            <b>{company.name}</b><br />
                                            {company.addressLine1}<br />
                                            {company.addressLine2}<br />
                                            {company.city} - {company.pincode}
                                        </div>
                                        <div className="card-footer">
                                            <table className="table">
                                                <tbody>
                                                    {phoneNumbers.map((phone, index) => (
                                                        <tr key={'phone_' + index} className="align-middle">
                                                            <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                                <FontAwesomeIcon icon={icons[phone.icon]} />
                                                            </td>
                                                            <td>
                                                                <div>{phone.label}</div>
                                                                <div className="fw-bold">{phone.number}</div>
                                                            </td>
                                                            <td style={{ width: "90px", textAlign: "right" }}>
                                                                <a
                                                                    className="btn btn-primary btn-sm"
                                                                    href={"tel:" + phone.number}
                                                                    style={{ textDecoration: "none", color: "#fff" }}
                                                                >
                                                                    <FontAwesomeIcon icon={faPhone} className="me-2" />
                                                                    Call
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <NavLink to="/" className="btn btn-danger w-100">
                                Back
                            </NavLink>
                        </div>
                    </div>
                </>
            }
        </div>
    );
}